import { Injectable } from '@angular/core';
import { StatusService } from '../../../shared/services/status.service';
import { StateService } from '../../../shared/services/state.service';
import { CountWidgetSettings } from 'app/shared/models/count-widget-settings';
import { SubjectTypeService } from 'app/shared/services/subject-type.service';
import { plural } from 'pluralize';
import { OrganisationService } from 'app/shared/services/organisation.service';
import { UserService } from 'app/shared/services/user.service';
import { User } from 'app/shared/models/user';
import { CategoryService } from 'app/shared/services/category.service';
import { LookupService } from 'app/shared/services/lookup.service';

@Injectable()
export class LabelService {
  constructor(
    private stateService: StateService,
    private statusService: StatusService,
    private subjectTypeService: SubjectTypeService,
    private organisationService: OrganisationService,
    private categoryService: CategoryService,
    private lookupService: LookupService,
    private userService: UserService
  ) {}

  get MAXLENGTH() {
    return 40;
  }

  get CONTEXTS() {
    return [
      { id: 0, name: 'All' },
      { id: -1, name: 'Filter by User' },
      { id: -2, name: 'Filter by Manager' },
    ];
  }

  getReviewTitle(
    settings: CountWidgetSettings,
    users?: number[],
    maxLength?: number
  ) {
    if (settings) {
      if (
        settings.caseOrReferralDueReview &&
        settings.caseOrReferralDueReview == true
      ) {
        const prefix = this.getPrefix(settings.context, settings, users);
        //prefix is the user context stuff

        const subjectType = this.getType(settings);
        const filter = this.getFilterLabel(settings);
        console.log(filter);

        const organisation = settings.organisationId
        ? this.organisationService.getName(settings.organisationId)
        : '';

        var e = prefix
          ? prefix + ' '
          : '' +
            ' ' +
            (subjectType ? subjectType + ' ' : '') +
            (filter ? filter + ' ' : '');
        console.log(e);
        return (
          prefix +
          ' ' +
          (organisation ? organisation + ' ' : '') +
          (subjectType ? subjectType + ' ' : '') +
          (filter ? filter + ' ' : '')
        ).substring(0, 55 || 60);
      }
    }
  }

  getDefaultTitle(
    settings: CountWidgetSettings,
    users?: number[],
    maxLength?: number
  ) {
    if (settings) {
      const prefix = this.getPrefix(settings.context, settings, users);

      const subjectType = settings.typeId
        ? this.subjectTypeService.getName(settings.typeId)
        : settings.state
        ? 'Task'
        : '';

      var organisation = settings.organisationId
        ? this.organisationService.getName(settings.organisationId)
        : '';

        // Stop title being 'All all cases' for example.
      if (prefix.toLocaleLowerCase()=='all' && organisation.toLocaleLowerCase()=='all')
        organisation='';

      return (
        prefix +
        ' ' +
        (organisation ? organisation + ' ' : '') +
        plural(subjectType)
      ).substring(0, maxLength || this.MAXLENGTH);
    }
    return '';
  }

  getFilterLabel(settings: CountWidgetSettings, maxLength?: number) {
    if (settings.filterId) {
      switch (settings.filterId) {
        case 1:
          return 'due Today';
        case 7:
          return 'due within the next 7 days';
        case 30:
          return 'due within the next 30 days';
      }
    }
  }

  getType(settings: CountWidgetSettings) {
    if (settings.typeId && settings.typeId == 1) {
      return 'Case reviews';
    }
    if (settings.typeId && settings.typeId == 2) {
      return 'Referral reviews';
    }
  }

  getDefaultCountLabel(settings: CountWidgetSettings, maxLength?: number) {
    if (settings && settings.status && settings.status.length > 0) {
      const status = this.MakeArrayFromString(settings.status);      
      return this.getStatusLabel(status, settings.typeId).substring(
        0,
        maxLength || this.MAXLENGTH
      );
    }
    if (settings && settings.stateId && settings.stateId >= 0) {
      return this.getStateLabel(settings.stateId).substring(
        0,
        maxLength || this.MAXLENGTH
      );
    }
    if (settings && settings.category && settings.category.length > 0) {
      const category = this.MakeArrayFromString(settings.category);
      return this.getCategoryLabel(category, settings.typeId).substring(
        0,
        maxLength || this.MAXLENGTH
      );
    }
    if (settings && settings.caseType && settings.caseType.length > 0) {
      const status = this.MakeArrayFromString(settings.caseType);
      return this.getCaseTypeLabel(status, settings.typeId).substring(
        0,
        maxLength || this.MAXLENGTH
      );
    }

    if (
      settings &&
      settings.caseOrReferralDueReview &&
      settings.caseOrReferralDueReview === true
    ) {
      //we know its from the subject review due widget
      //Context first, then the type
      if (settings.typeId && settings.typeId == 1) {
        //return basic case label
        return 'Cases Due Review Count'; // + filter?
      }
      if (settings.typeId && settings.typeId == 2) {
        //we know its a referral
        return 'Referrals Due Review Count';
      }

      return 'Review Count';
    }

    if (
      settings &&
      settings.referralCounts &&
      settings.referralCounts === true
    ) {
      return 'Referral Count'.toUpperCase();
    }
    return '';
  }
  getDefaultExtraCountLabel(settings: CountWidgetSettings, maxLength?: number) {
    if (settings && settings.showExtra) {
      let label = '';
      if (settings.extraStatus && settings.extraStatus.length > 0) {
        const extraStatus = this.MakeArrayFromString(settings.extraStatus);
        label = this.getStatusLabel(extraStatus, settings.extraTypeId);
      }
      if (settings.extraStateId && settings.extraStateId > 0) {
        label = this.getStateLabel(settings.extraStateId);
      }
      if (
        settings &&
        settings.extraCategory &&
        settings.extraCategory.length > 0
      ) {
        const extraCategory = this.MakeArrayFromString(settings.category);
        label = this.getCategoryLabel(
          extraCategory,
          settings.extraTypeId
        ).substring(0, maxLength || this.MAXLENGTH);
      }
      if (
        settings &&
        settings.extraCaseType &&
        settings.extraCaseType.length > 0
      ) {
        const extraCaseType = this.MakeArrayFromString(settings.extraCaseType);
        label = this.getCaseTypeLabel(
          extraCaseType,
          settings.extraTypeId
        ).substring(0, maxLength || this.MAXLENGTH);
      }

      const t = settings.extraTypeId
        ? plural(this.subjectTypeService.getName(settings.extraTypeId))
        : '';
      if (label.includes('+ ')) {
        return label.substring(0, maxLength || this.MAXLENGTH);
      } else {
        return (label + (label && t ? ' ' : '') + t).substring(
          0,
          maxLength || this.MAXLENGTH
        );
      }
    }
    return '';
  }

  private getStatusLabel(status: string[], subjectTypeId: number): string {
    var blankFound = status.filter((i) => Number(i) == -1).length;
    const names: string[] = [];
    if (blankFound) names.push('Blank');

    status.forEach((i: string) => {
      if (Number(i) > 0) {
        names.push(this.statusService.getDescription(Number(i)));
      }
    });
    return this.MakeStringFromArray(names); // return names.join(', ');
  }

  private getStateLabel(state: number) {
    return state
      ? state > 0
        ? this.stateService.getName(state)
        : 'Total'
      : '';
  }

  private MakeArrayFromString(status: string | string[]): string[] {    
    return Array.isArray(status) ? status : status.split(',');
  }

  private MakeStringFromArray(names: string[]): string {
    if (names == undefined || names == null || names.length < 1) return '';

    var s: string = '';
    var j: number = names.length;
    var BreakException = {};
    try {
      names.forEach((i) => {
        if (i.length + s.length + 2 < 28) {
          if (j < names.length) s = s + ', ';
          s = s + i;
        } else {
          if (j > 1) s = s + ' + ' + String(j) + ' others';
          else if (j == 1) s = s + ' + 1 other';
          throw BreakException;
        }
        j = j - 1;
      });
    } catch {}
    return s;
  }

  private getCategoryLabel(category, subjectTypeId: number): string {
    var blankFound = category.filter((i) => Number(i) == -1).length;
    const names: string[] = [];
    if (blankFound) names.push('Blank');

    category.forEach((i) => {
      if (i > 0) {
        names.push(this.categoryService.getDescription(Number(i)));
      }
    });
    return this.MakeStringFromArray(names); // return names.join(', ');
  }

  private getCaseTypeLabel(caseType: string[], subjectTypeId: number) {
    // Convert caseType list into array
    var blankFound = caseType.filter((i) => Number(i) == -1).length;

    const names: string[] = [];
    if (blankFound) names.push('Blank');

    caseType.forEach((i) => {
      if (Number(i) > 0) {
        names.push(this.lookupService.getDescription(Number(i)));
      }
    });
    return this.MakeStringFromArray(names); // return names.join(', ');
  }

  private getPrefix(context: any, settings: any, users?: number[]) {
    const names: string[] = [];
    if (context && context.length > 0) {
      context = this.getContext(context);
      const meId = this.userService.getCurrentUserId();
      context.forEach((i) => {
        switch (i) {
          case 0:
            names.push('All');
            break;
          case -1:
            names.push(this.onlyCurrentUser(users) ? 'My' : 'Assigned');
            break;
          case -2:
            names.push('Managed');
            break;
          default:
            this.userService
              .getById(i)
              .subscribe((user: User) => {
                if (user) {
                  names.push(user.id === meId ? 'Me' : new User(user).fullName);
                }
              });
            break;
        }
      });
    }
    if (names.length === 1 && names[0] === 'Me') {
      names[0] = 'My';
    }
    console.log(settings);    
    return (
      names.join(', ') +
      (settings.referralCounts && settings.referralCounts === true ? '' : '')
    );
  }

  getContext(context): number[] {
    let result: any[] = [];
    if (context && context.length > 0) {
      if (!Array.isArray(context)) {
        const newContext = this.CONTEXTS.find(
          (i) => context.toLowerCase() === i.name.toLowerCase()
        );
        result.push(newContext ? newContext.id : 0);
      } else {
        result = context;
      }
    }
    return result.length > 0 ? result : context;
  }

  onlyCurrentUser(users: number[] | undefined): boolean {
    if (users) {
      return (
        users.length === 1 && users[0] === this.userService.getCurrentUserId()
      );
    } else {
      return false;
    }
  }
}
